import {
  Paper,
  Grid2,
  Card,
  Typography,
  CardActionArea,
  Box,
  FormControl,
  Button,
  Dialog,
  InputAdornment,
  Input,
  Stack,
  IconButton,
  Modal,
  ButtonGroup,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import classes from "./css/products-list.module.css";
import * as services from "./../../services/saleng";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import toast, { Toaster } from "react-hot-toast";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { useCart } from "./../../CartContext";
import { useRef } from "react";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import CloseIcon from "@mui/icons-material/Close";
import ScaleOutlinedIcon from "@mui/icons-material/ScaleOutlined";
// import ReactWebCam from "react-webcam"; // กล้องปิดใช้งานชั่วคราว
import ImageCell from "../../components/modal/ImageCell";

const beep = new Audio("/sounds/beep.mp3");

const { v4: uuidv4 } = require("uuid");

function formatNumber(number) {
  return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function SimpleDialog(props) {
  // const webcamRef = useRef(null); // กล้องปิดใช้งานชั่วคราว

  const { onClose, selectedValue, open, setOpen } = props;
  const [value, setValue] = useState(selectedValue.weight || 0);
  const [cal_weight, setCalweight] = useState(0);
  const [weight, setWeight] = useState("");
  const [moisture_weight, setMoistureweight] = useState(0);
  const [impurity_weight, setImpurityweight] = useState(0);
  const [car_weight, setCarweight] = useState(0);
  const [other_weight, setOtherweight] = useState(0);
  const [formattedCalWeight, setFormattedCalWeight] = useState("");
  const [mute, setMute] = useState(false); // สถานะปิดเสียง
  const maxWeightRef = useRef(0);
  // const lastWeightRef = useRef(0);
  const recordedRef = useRef(false);
  const lastWeightRef = useRef(null);
  const latestScaleWeightRef = useRef(null);
  const stableStartTimeRef = useRef(null);
  const beepPlayedRef = useRef(false);
  const muteRef = useRef(mute);

  useEffect(() => {
    muteRef.current = mute;
  }, [mute]);

  useEffect(() => {
    // const socket = new WebSocket("ws://192.168.0.246:3001");
    const socket = new WebSocket("ws://localhost:3001/ws");
    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.weight == null) return;

        const rawWeight = Number(data.weight);
        if (!Number.isFinite(rawWeight)) return;

        const roundedWeight = Number(rawWeight.toFixed(3));
        latestScaleWeightRef.current = roundedWeight.toFixed(3);

        if (
          lastWeightRef.current === null ||
          Math.abs(roundedWeight - lastWeightRef.current) > 0.05
        ) {
          lastWeightRef.current = roundedWeight;
          stableStartTimeRef.current = Date.now();
          beepPlayedRef.current = false;
        }
      } catch (error) {
        console.error("Unable to read weight from scale", error);
      }
    };
    const interval = setInterval(() => {
      if (lastWeightRef.current !== null) {
        const elapsed = Date.now() - stableStartTimeRef.current;
        if (
          elapsed >= 2500 &&
          !beepPlayedRef.current &&
          lastWeightRef.current !== 0 &&
          !muteRef.current
        ) {
          beep.play().catch((e) => console.error("เสียงเล่นไม่สำเร็จ", e));
          beepPlayedRef.current = true;
        }
      }
    }, 200);

    //v1//
    // socket.onmessage = (event) => {
    //   const data = JSON.parse(event.data);
    //   if (data.weight) {
    //     setWeight(
    //       data.weight.toLocaleString("en-US", { maximumFractionDigits: 2 })
    //     );
    //   }
    // };
    //v2//
    // socket.onmessage = (event) => {
    //   const data = JSON.parse(event.data);
    //   if (!data.weight) return;

    //   const weight = parseFloat(data.weight);
    //   if (isNaN(weight)) return;

    //   setDisplayWeight(weight.toFixed(3));

    //   if (weight > maxWeightRef.current) {
    //     maxWeightRef.current = weight;
    //     recordedRef.current = false;
    //   }

    //   if (
    //     weight < lastWeightRef.current &&
    //     !recordedRef.current &&
    //     maxWeightRef.current > 0.01
    //   ) {
    //     const maxW = maxWeightRef.current.toFixed(3);
    //     setWeight(maxW);
    //     recordedRef.current = true;
    //     console.log("✅ บันทึกน้ำหนักสูงสุด:", maxW);
    //   }

    //   lastWeightRef.current = weight;
    // };

    return () => {
      socket.close();
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const total =
      Number(weight) -
      Number(moisture_weight) -
      Number(impurity_weight) -
      Number(car_weight) -
      Number(other_weight);

    const finalWeight = total >= 0 ? total : 0;
    setCalweight(finalWeight);
    setValue(finalWeight);

    setFormattedCalWeight(
      finalWeight.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }, [weight, moisture_weight, impurity_weight, car_weight, other_weight]);

  const handleWeightChange = (event) => {
    const nextWeight = event.target.value;
    if (/^\d*\.?\d{0,3}$/.test(nextWeight)) {
      setWeight(nextWeight);
    }
  };

  const handleReadScale = () => {
    if (latestScaleWeightRef.current === null) {
      toast.error("ยังไม่ได้รับข้อมูลจากตราชั่ง");
      return;
    }

    setWeight(latestScaleWeightRef.current);
  };

  const handleClose = () => {
    maxWeightRef.current = 0;
    lastWeightRef.current = 0;
    latestScaleWeightRef.current = null;
    recordedRef.current = false;
    setWeight(0);
    setMoistureweight(0);
    setImpurityweight(0);
    setCarweight(0);
    setValue(0);
    setCalweight(0);
    setOtherweight(0);
    setOpen(false);
  };

  const handleSummit = () => {
    if (cal_weight <= 0) {
      alert("น้ำหนักรวมไม่ถูกต้องกรุณาตรวจสอบอีกครั้งครับ");
    } else {
        const total =
          Number(moisture_weight) +
          Number(impurity_weight) +
          Number(car_weight) +
          Number(other_weight);
        onClose({
          ...selectedValue,
          weight: Number(value),
          // file: data[0], // เปิดใช้พร้อมส่วนกล้องและอัปโหลดรูปอีกครั้งภายหลัง
          weight_no_cal: weight,
          moisture_weight: moisture_weight,
          impurity_weight: impurity_weight,
          car_weight: car_weight,
          other_weight: other_weight,
          deduct_weight: total,
        });
        setWeight(0);
        setMoistureweight(0);
        setImpurityweight(0);
        setCarweight(0);
        setValue(0);
        setCalweight(0);
        setOtherweight(0);
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      PaperProps={{
        sx: {
          width: "700px",
          maxWidth: "100%", // ป้องกันล้นจอ
        },
      }}
    >
      <Box
        sx={{ p: 3, display: "flex", alignItems: "center" }}
      >
        {/* <Box sx={{ flex: 1, mr: 2 }}>
          <ReactWebCam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            screenshotQuality={3}
            width="1280px"
            height="720px"
            videoConstraints={{
              width: 1280,
              height: 720,
              facingMode: "user",
            }}
          />
        </Box> */}
        <Box sx={{ flex: 1 }}>
          <Typography variant="h5" gutterBottom align="center">
            กรอกข้อมูลน้ำหนัก
          </Typography>
          <Stack spacing={2} sx={{ p: 2 }}>
            {/* น้ำหนักที่ชั่ง */}
            <Box display="flex" alignItems="center" gap={2} mb={2}>
              <Typography
                variant="h6"
                sx={{ whiteSpace: "nowrap", minWidth: "170px", fontSize: "1.5rem" }}
              >
                น้ำหนักที่ชั่ง :
              </Typography>

              <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
                <FormControl fullWidth variant="standard">
                  <Input
                    type="text"
                    value={weight}
                    onChange={handleWeightChange}
                    placeholder="0.000"
                    inputMode="decimal"
                    sx={{
                      fontSize: "2.25rem",
                      fontWeight: "bold",
                      minHeight: "64px",
                      "& input": { py: 1 },
                    }}
                    endAdornment={
                      <InputAdornment position="end" sx={{ fontSize: "1.5rem" }}>
                        Kg
                      </InputAdornment>
                    }
                    inputProps={{
                      "aria-label": "น้ำหนักที่ชั่ง",
                      pattern: "[0-9]*[.]?[0-9]*",
                    }}
                  />
                </FormControl>

                <Box sx={{ ml: 1, display: "flex", alignItems: "center" }}>
                  <IconButton
                    aria-label="ดึงน้ำหนักจากตราชั่ง"
                    title="ดึงน้ำหนักจากตราชั่ง"
                    color="primary"
                    onClick={handleReadScale}
                    sx={{ width: 64, height: 64 }}
                  >
                    <ScaleOutlinedIcon sx={{ fontSize: "2.25rem" }} />
                  </IconButton>
                  <button onClick={() => setMute((prev) => !prev)}>
                    {mute ? "🔇" : "🔊"}
                  </button>
                </Box>
              </Box>
            </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography
                variant="h6"
                sx={{ whiteSpace: "nowrap", minWidth: "150px" }}
              >
                หักความชื้น (กก.) :
              </Typography>
              <FormControl fullWidth variant="standard">
                <Input
                  type="number"
                  placeholder={Number(moisture_weight)}
                  value={moisture_weight}
                  onChange={(e) => setMoistureweight(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">Kg</InputAdornment>
                  }
                  aria-describedby="standard-weight-helper-text"
                  inputProps={{ "aria-label": "weight" }}
                />
              </FormControl>
            </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography
                variant="h6"
                sx={{ whiteSpace: "nowrap", minWidth: "150px" }}
              >
                หักสิ่งเจือปน :
              </Typography>
              <FormControl fullWidth variant="standard">
                <Input
                  type="number"
                  placeholder={Number(impurity_weight)}
                  value={impurity_weight}
                  onChange={(e) => setImpurityweight(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">Kg</InputAdornment>
                  }
                  aria-describedby="standard-weight-helper-text"
                  inputProps={{ "aria-label": "weight" }}
                />
              </FormControl>
            </Box>

            <Box display="flex" alignItems="center" gap={2}>
              <Typography
                variant="h6"
                sx={{ whiteSpace: "nowrap", minWidth: "150px" }}
              >
                หักน้ำหนักรถ :
              </Typography>
              <FormControl fullWidth variant="standard">
                <Input
                  type="number"
                  placeholder={Number(car_weight)}
                  value={car_weight}
                  onChange={(e) => setCarweight(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">Kg</InputAdornment>
                  }
                  aria-describedby="standard-weight-helper-text"
                  inputProps={{ "aria-label": "weight" }}
                />
              </FormControl>
            </Box>

            <Box display="flex" alignItems="center" gap={2}>
              <Typography
                variant="h6"
                sx={{ whiteSpace: "nowrap", minWidth: "150px" }}
              >
                หักน้ำหนัก อื่น ๆ :
              </Typography>
              <FormControl fullWidth variant="standard">
                <Input
                  type="number"
                  placeholder={Number(other_weight)}
                  value={other_weight}
                  onChange={(e) => setOtherweight(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">Kg</InputAdornment>
                  }
                  aria-describedby="standard-weight-helper-text"
                  inputProps={{ "aria-label": "weight" }}
                />
              </FormControl>
            </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography
                variant="h6"
                sx={{ whiteSpace: "nowrap", minWidth: "150px", color: "green" }}
              >
                น้ำหนักคงเหลือ :
              </Typography>
              <FormControl fullWidth variant="standard">
                <Input
                  type="text"
                  value={formattedCalWeight}
                  disabled
                  endAdornment={
                    <InputAdornment position="end">Kg</InputAdornment>
                  }
                  inputProps={{ "aria-label": "weight" }}
                  sx={{
                    color: "green",
                    fontWeight: "bold",
                    fontSize: "1.25rem",
                  }}
                />
              </FormControl>
            </Box>
            <Box display="flex" justifyContent="center" mt={2} gap={2}>
              <Button
                variant="outlined"
                color="error"
                sx={{ height: "2.5rem", width: "8rem", fontSize: "1.2rem" }}
                onClick={handleClose}
              >
                ยกเลิก
              </Button>
              <Button
                variant="contained"
                color="success"
                sx={{ height: "2.5rem", width: "8rem", fontSize: "1.2rem" }}
                onClick={handleSummit}
              >
                ตกลง
              </Button>
              {/* <Button
                variant="contained"
                color="success"
                sx={{ height: "2.5rem", width: "8rem", fontSize: "1.2rem" }}
                onClick={() => {
                  handleSummit();
                }}
              >
                {" "}
                ตกลง
              </Button> */}
            </Box>
          </Stack>
        </Box>
      </Box>
    </Dialog>
  );
}
const Page = ({ tabId, tabData, onTransactionSaved }) => {
  const { cart, dispatch } = useCart();
  const [cards, setCards] = useState([]);
  const [data, setData] = useState([]);
  // const [selectedCard, setSelectedCard] = useState(0);
  const [categories, setCategories] = useState([]);
  const [filter, setFilter] = useState("ทุกประเภท");
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(0);
  const [productSearch, setProductSearch] = useState("");
  const [open_add_phone, setOpenAddphone] = useState(false);
  const [open_print, setOpenPrint] = useState(false);
  const [pdf_data, setPDFData] = useState();

  const customer_detail = Array.isArray(cart[tabId]?.customerDetail)
    ? cart[tabId].customerDetail.map((item) => ({ ...item }))
    : [];
  const customerLevel = cart[tabId]?.customerLevel ?? "ระดับทั่วไป";
  const customerName = cart[tabId]?.customerName ?? "";
  const phoneNumber = cart[tabId]?.phoneNumber ?? "";
  const setCustomerName = (name) => {
    dispatch({
      type: "SET_CUSTOMER_INFO",
      payload: { tabId, customerName: name },
    });
  };
  const setPhoneNumber = (phone) => {
    dispatch({
      type: "SET_CUSTOMER_INFO",
      payload: { tabId, phoneNumber: phone },
    });
  };
  const columns = [
    {
      field: "productName",
      headerName: "สินค้า",
      minWidth: 200,
      headerAlign: "center",
    },
    {
      field: "weight_no_cal",
      headerName: "น้ำหนักชั่ง",
      minWidth: 140,
      headerAlign: "center",

      renderCell: (params) => {
        const { weight_no_cal } = params.row;
        return (
          <Box display="flex" alignItems="center" justifyContent="center">
            <Box mx={1}>
              {formatNumber(Number(weight_no_cal ?? 0))}{" "}
              <span style={{ color: "gray" }}>kg</span>
            </Box>
            {/* <EditIcon
              variant="outlined"
              onClick={handleEditClick(params)}
              size="small"
              color="inherit"
            /> */}
          </Box>
        );
      },
    },
    {
      field: "deduct_weight",
      headerName: "น้ำหนักหัก",
      minWidth: 140,
      headerAlign: "center",

      renderCell: (params) => {
        const { deduct_weight } = params.row;
        return (
          <Box display="flex" alignItems="center" justifyContent="center">
            <Box mx={1}>
              {formatNumber(Number(deduct_weight ?? 0))}{" "}
              <span style={{ color: "gray" }}>kg</span>
            </Box>
            {/* <EditIcon
              variant="outlined"
              onClick={handleEditClick(params)}
              size="small"
              color="inherit"
            /> */}
          </Box>
        );
      },
    },
    {
      field: "weight",
      headerName: "น้ำหนักสุทธิ",
      minWidth: 140,
      headerAlign: "center",

      renderCell: (params) => {
        const { weight } = params.row;
        return (
          <Box display="flex" alignItems="center" justifyContent="center">
            <Box mx={1}>
              {formatNumber(weight)} <span style={{ color: "gray" }}>kg</span>
            </Box>
            {/* <EditIcon
              variant="outlined"
              onClick={handleEditClick(params)}
              size="small"
              color="inherit"
            /> */}
          </Box>
        );
      },
    },
    {
      field: "pricePerUnit",
      headerName: "ราคา/น้ำหนัก",
      type: "number",
      maxWidth: 100,
      headerAlign: "center",
    },
    {
      field: "total",
      headerName: "รวม(บาท)",
      maxWidth: 100,
      type: "number",
      headerAlign: "center",
    },
    {
      field: "file",
      headerName: "รูปถ่ายชั่งน้ำหนัก",
      minWidth: 150,
      headerAlign: "center",
      renderCell: (params) => <ImageCell value={params.value} />,
    },
    {
      field: "actions",
      headerName: "ตัวเลือก",
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      renderCell: ({ id }) => {
        return [
          <GridActionsCellItem
            key={`${id}-delete`}
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="error"
          />,
        ];
      },
    },
  ];

  const addItemToCart = (item) => {
    if (tabId) {
      dispatch({ type: "ADD_ITEM", payload: { tabId, item } });
    }
  };
  const setLevel = (e) => {
    const customerLevel = e;
    if (tabId) {
      dispatch({ type: "ADD_ITEM", payload: { tabId, customerLevel } });
    }
  };
  // const updateItemQuantity = (id, payload) => {
  //   console.log("payload", payload);
  //   if (tabId) {
  //     dispatch({
  //       type: "UPDATE_ITEM",
  //       payload: {
  //         tabId,
  //         item: { id, ...payload },
  //       },
  //     });
  //   }
  // };
  const removeItemFromCart = (id) => {
    if (tabId) {
      dispatch({ type: "REMOVE_ITEM", payload: { tabId, id } });
    }
  };
  const clearCart = () => {
    if (tabId) {
      dispatch({ type: "CLEAR_CART", payload: { tabId } });
    }
  };
  const rows = Array.isArray(cart[tabId]?.items)
    ? cart[tabId].items.map((item) => ({ ...item }))
    : [];


  const handleDeleteClick = (id) => () => {
    // setRows((prevRows) => prevRows.filter((row) => row.id !== id));
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      title: "ยืนยันที่จะลบ?",
      text: "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        toast.success(`ลบรายการสำเร็จ!`);
        removeItemFromCart(id);
      }
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await services.getProducts();
        const products = response.data.data;
        const productsWithIndex = products.map((item, index) => ({
          ...item,
          // id: index + 1,
          productId: item.id,
        }));
        const categories = [
          ...new Set(products.map((product) => product.category)),
        ];
        setCategories(categories);
        setCards(productsWithIndex);
        setData(productsWithIndex);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setFilter(value);

    if (value === "ทุกประเภท") {
      setCards(data);
    } else {
      const filteredProducts = data.filter(
        (product) => product.category === value
      );
      // console.log("filteredProducts", filteredProducts);
      setCards(filteredProducts);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);

    const {
      title,
      id,
      weight,
      edit,
      file,
      weight_no_cal,
      deduct_weight,
      moisture_weight,
      impurity_weight,
      car_weight,
      other_weight,
    } = value;

    if (!edit) toast.success(`${title}`);
    let price;
    if (customerLevel === "ระดับ VIP") {
      price = value.price_tier_1;
    } else if (customerLevel === "ระดับสมาชิก") {
      price = value.price_tier_2;
    } else {
      price = value.price_tier_3;
    }
    const item = {
      id: rows.length + 1,
      productName: title,
      weight_no_cal: weight_no_cal,
      deduct_weight: deduct_weight ===""? 0: deduct_weight,
      moisture_weight: moisture_weight ===""? 0:moisture_weight,
      impurity_weight: impurity_weight ===""? 0:impurity_weight,
      car_weight: car_weight ===""? 0:car_weight,
      other_weight: other_weight ===""? 0:other_weight,
      productId: id,
      weight: weight,
      file: file,
      pricePerUnit: price,
      total: weight * price,
    };
    console.log(item);
    addItemToCart(item);
  };

  const handleClick = (product) => {
    handleClickOpen();
    setSelectedValue(product);
  };

  const handleDeleteAll = () => {
    clearCart();
    toast.error(`ลบรายการทั้งหมดแล้ว!`);
  };
  const handlePrint = (shouldPrint) => {
    if (shouldPrint && pdf_data?.transactionId) {
      window.open(`/receipt/${pdf_data.transactionId}`, "_blank", "noopener,noreferrer");
    }
  };
  const handleSaveTransaction = async (summit) => {
    if (rows.length === 0) {
      toast.error(`สร้างรายการไม่สำเร็จ!`);
      return;
    }

    if (!customerName.trim()) {
      toast.error("กรุณากรอก ชื่อ-นามสกุล ลูกค้า");
      return;
    }

    const transactionId = uuidv4();
    const totalAmount = rows
      .map((v) => v.total)
      .reduce((acc, current) => acc + current, 0);

    const totalWeight = rows
      .map((v) => v.weight)
      .reduce((acc, current) => acc + current, 0);

    if (customer_detail.length !== 0) {
      let point = customer_detail[0].point + totalAmount;
      setPhoneNumber(customer_detail[0].phone);
      await services.addPointToUser(customer_detail[0].id, {
        point: point,
      });
    } else {
      setOpenAddphone(true);
    }

    if (summit || customer_detail.length !== 0) {
      setOpenAddphone(false);
      const resolvedPhoneNumber =
        customer_detail.length !== 0
          ? customer_detail[0].phone
          : phoneNumber.trim();
      const payload = {
        transactionId,
        totalAmount,
        totalWeight,
        phoneNumber: resolvedPhoneNumber,
        customerName: customerName.trim(),
        line_uid:
          customer_detail.length !== 0 ? customer_detail[0].line_uid : "",
        items: [...rows],
        // items: rows.map(({ id, ...rest }) => ({
        //   ...rest,
        //   file: "",
        // })),
      };
      services
        .createTransaction(payload)
        .then((response) => {
          toast.success("เพิ่มรายการสำเร็จ!");
          console.log("Transaction created successfully:", response.data.data);
          clearCart();
          setPDFData(response.data.data);
          onTransactionSaved?.();
          if (tabId === 1) {
            setOpenPrint(true);
          }
        })
        .catch((error) => {
          toast.error("เพิ่มรายการไม่สำเร็จ!");
          console.error("Error creating Transaction:", error);
        });
    }
  };
  return (
    <>
      <Toaster position="bottom-right" reverseOrder={false} />
      <SimpleDialog
        selectedValue={selectedValue}
        open={open}
        onClose={handleClose}
        setOpen={setOpen}
      />
      <div className="p-5">
        <Grid2 container spacing={0.5}>
          <Grid2 size={5}>
            <Paper
              className={classes["products-container"]}
              elevation={5}
              square
              style={{
                display: "flex",
                flexDirection: "column",
                height: "80vh",
              }}
            >
              <Box sx={{ mb: 2, padding: 0 }}>
                <TextField
                  size="small"
                  label="ชื่อลูกค้า"
                  placeholder="กรอกชื่อลูกค้า"
                  variant="outlined"
                  fullWidth
                  required
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                />
                <FormControl fullWidth size="small" sx={{ mt: 2 }}>
                  <label style={{ marginBottom: 8, display: "block" }}>
                    ระดับลูกค้า
                  </label>
                  <ButtonGroup variant="outlined" fullWidth>
                    <Button
                      variant={
                        customerLevel === "ระดับทั่วไป" ? "contained" : "outlined"
                      }
                      onClick={() => setLevel("ระดับทั่วไป")}
                      disabled={rows.length > 0}
                    >
                      ระดับทั่วไป
                    </Button>
                    <Button
                      variant={
                        customerLevel === "ระดับสมาชิก" ? "contained" : "outlined"
                      }
                      onClick={() => setLevel("ระดับสมาชิก")}
                      disabled={rows.length > 0}
                    >
                      ระดับสมาชิก
                    </Button>
                    <Button
                      variant={
                        customerLevel === "ระดับ VIP"
                          ? "contained"
                          : "outlined"
                      }
                      onClick={() => setLevel("ระดับ VIP")}
                      disabled={rows.length > 0}
                    >
                      ระดับ VIP
                    </Button>
                  </ButtonGroup>
                </FormControl>
              </Box>

              <Box style={{ flex: 1 }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  autoPageSize
                  disableColumnSorting
                  disableColumnFilter
                  disableColumnMenu
                  getRowId={(row) => row.id}
                  // slots={{
                  //   noRowsOverlay: CustomNoRowsOverlay,
                  // }}
                />
              </Box>
              <Box className={classes["title-container"]} sx={{ mt: 2 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    gap: "0.5rem",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p>ราคาทั้งหมด</p>
                    <p>
                      {formatNumber(
                        rows
                          .map((v) => v.total)
                          .reduce((acc, current) => acc + current, 0)
                      )}
                      {" บาท"}
                    </p>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p>ภาษี</p>
                    <p>0.00 {" บาท"}</p>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <b>ราคาสุทธิ</b>
                    <b>
                      {formatNumber(
                        rows
                          .map((v) => v.total)
                          .reduce((acc, current) => acc + current, 0)
                        // .reduce((acc, current) => acc + current, 0) + 100
                      )}
                      {" บาท"}
                    </b>
                  </div>
                </div>
              </Box>
            </Paper>
          </Grid2>
          <Grid2 size={1.6}>
            <Paper
              className={classes["products-container"]}
              elevation={5}
              square
              style={{
                display: "flex",
                flexDirection: "column",
                height: "80vh",
              }}
            >
              <Box sx={{ p: 1, pb: 0 }}>
                <TextField
                  size="small"
                  label="ค้นหาสินค้า"
                  placeholder="พิมพ์ชื่อสินค้า"
                  fullWidth
                  value={productSearch}
                  onChange={(event) => setProductSearch(event.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box
                sx={{
                  // width: 180,
                  flexShrink: 0,
                  backgroundColor: "#fff",
                  overflowY: "auto",
                  paddingRight: 1,
                  boxSizing: "border-box",
                }}
              >
                <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
                  หมวดหมู่
                </Typography>
                <Button
                  variant={filter === "ทุกประเภท" ? "contained" : "outlined"}
                  fullWidth
                  sx={{ mb: 2 }}
                  onClick={() =>
                    handleChange({ target: { value: "ทุกประเภท" } })
                  }
                >
                  ทุกประเภท
                </Button>
                {categories.map((name, index) => (
                  <Button
                    key={index}
                    variant={filter === name ? "contained" : "outlined"}
                    fullWidth
                    sx={{ mb: 1, fontWeight: "bold" }}
                    onClick={() => handleChange({ target: { value: name } })}
                  >
                    {name}
                  </Button>
                ))}
              </Box>
            </Paper>
          </Grid2>

          <Grid2 size={5.4}>
            <Paper
              className={classes["products-container"]}
              elevation={5}
              square
              style={{
                display: "flex",
                flexDirection: "column",
                height: "80vh",
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  overflowY: "auto",
                  p: 1,
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: 1,
                  }}
                >
                  {cards
                    .filter((card) =>
                      filter === "ทุกประเภท" ? true : card.category === filter
                    )
                    .filter((card) =>
                      String(card.title ?? "")
                        .toLowerCase()
                        .includes(productSearch.trim().toLowerCase())
                    )
                    .map((card, index) => (
                      <Card
                        key={index}
                        sx={{
                          height: 100,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          p: 0,
                          m: 0,
                          overflow: "hidden",
                        }}
                      >
                        <CardActionArea
                          onClick={() => handleClick(card)}
                          sx={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#ffebee",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0.5,
                          }}
                        >
                          <Typography
                            variant="body2"
                            fontWeight="bold"
                            // noWrap
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              textAlign: "center",
                              width: "100%",
                            }}
                          >
                            {card.title}
                          </Typography>
                        </CardActionArea>
                      </Card>
                    ))}
                </Box>
              </Box>

              {/* Bottom Buttons */}
              <Box
                sx={{
                  padding: "1rem",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "1rem",
                  borderTop: "1px solid #ccc",
                  backgroundColor: "#fff",
                }}
              >
                <Button
                  sx={{ height: "4rem", flex: 1 }}
                  variant="contained"
                  startIcon={<DeleteIcon />}
                  color="error"
                  onClick={handleDeleteAll}
                >
                  ลบรายการทั้งหมด
                </Button>
                <Button
                  sx={{ height: "4rem", flex: 1 }}
                  variant="contained"
                  startIcon={<ShoppingCartIcon />}
                  color="success"
                  onClick={() => handleSaveTransaction(false)}
                >
                  วางออเดอร์สินค้า
                </Button>
              </Box>
            </Paper>
          </Grid2>
        </Grid2>
        <Modal open={open_add_phone} onClose={() => setOpenAddphone(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              textAlign: "center",
            }}
          >
            <Typography variant="h7" gutterBottom>
              กรุณากรอกเบอร์โทรศัพท์ลูกค้า (ไม่บังคับ)
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              label="เบอร์โทรศัพท์ลูกค้า"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              sx={{ pt: 2, mb: 2 }}
            />
            <Button
              sx={{ height: "4rem", flex: 1 }}
              fullWidth
              variant="contained"
              startIcon={<ShoppingCartIcon />}
              color="success"
              onClick={() => handleSaveTransaction(true)}
            >
              วางออเดอร์สินค้า
            </Button>
          </Box>
        </Modal>
        <Modal open={open_print} onClose={() => setOpenPrint(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              textAlign: "center",
            }}
          >
            <Typography variant="h6" gutterBottom>
              ต้องการพิมพ์ใบเสร็จหรือไม่
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2, // ระยะห่างระหว่างปุ่ม
                mt: 2, // margin ด้านบน
              }}
            >
              <Button
                sx={{ height: "4rem", flex: 1 }}
                variant="contained"
                startIcon={<CloseIcon />}
                color="error"
                onClick={() => {
                  handlePrint(false);
                  setOpenPrint(false);
                }}
              >
                ไม่พิมพ์
              </Button>
              <Button
                sx={{ height: "4rem", flex: 1 }}
                variant="contained"
                startIcon={<PrintIcon />}
                color="success"
                onClick={() => {
                  handlePrint(true);
                  setOpenPrint(false);
                }}
              >
                พิมพ์ใบเสร็จ
              </Button>
            </Box>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default Page;
